/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  LetterbookPromptType,
  LetterlistTableColumnSettingType,
} from "features/Letterbooks/types";
import LetterbookCell from "../LetterbookCell";
import PromptBookVote from "components/prompts/PromptBookVote";

export default function PromptVote({
  letterbook,
}: {
  letterbook: LetterbookPromptType;
}) {
  const { data } = letterbook;

  return (
    <LetterbookCell className="font-bold text-lg">
      <PromptBookVote promptBook={data.promptBook} />
    </LetterbookCell>
  );
}

export const settings = {
  key: "PromptVote",
  title: "Vote",
} as LetterlistTableColumnSettingType;
